import styled from 'styled-components';



interface ResponsiveProps {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
}


export const BlogSectionWrapper = styled.div<ResponsiveProps>`
  flex-direction: column;
  align-items: center;
  padding: 8px;
  border-radius: 15px;
  background-color: '#f0dab1';
`;

export const NavigationButton = styled.button<ResponsiveProps>`
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
  height: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '14px' : isMobileMedium ? '18px' : isMobileBig ? '22px' : '22px' };
  font-size: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '7px' : isMobileMedium ? '10px' : isMobileBig ? '15px' : '15px' };
  text-align: center;
  vertical-align: center;
  cursor: pointer;
  //margin: 0 8px;
  border-radius: 4px;

  &:disabled {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
    border-color: ${({ theme }) => theme.colors.primary};
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.primary};
    color: #fff;
  }
`;

export const NavigationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const CardsContainer = styled.div<ResponsiveProps>`
  display: flex;
  
  padding: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '4px' : isMobileMedium ? '6px' : isMobileBig ? '8px' : isMiniNotebook ? '12px' : '16px'};
  
  justify-content: space-between;
  align-items: ${({ isMobileMini }) => (isMobileMini ? 'stretch' : 'center')};
  margin-bottom: '35px';
  //background-color: wheat;
`;
